export default "__VITE_ASSET__DJFovA4v__"